import styled from 'styled-components'
import { Colors, Breakpoints } from './../../utils/variables'

export const Wrapper = styled.button`
    display: block;
	position: relative;
	
	padding: 30px;

    border: none;
    outline: none;

    margin-right: 10px;

    background-color: transparent;

    span {
        background-color: ${props => (props.theme === 'dark') ? `${Colors.blue}` : `${Colors.white}`};
    }

    ${({ active }) => active && `
        display: block;

        span {
            background-color: ${Colors.blue}; 

            &:nth-of-type(1) {
                top: 50%;
                transform: translateY(-50%) rotate(45deg);
            }

            &:nth-of-type(2) {
                opacity: 0;
                left: 2px;
            }

            &:nth-of-type(3) {
                top: 50%;
                transform: translateY(-50%) rotate(-45deg);
            }
        }
    `}
`

export const Inner = styled.div`
	position: relative;
	
	width: 16px;
	height: 12px;
	
	@media screen and (min-width: ${Breakpoints.wide}) {
        display: none;
    }
`

export const Line = styled.span`
    position: absolute;

    top: 0;
    left: 0;

    width: 100%;
    height: 1px;

    &:nth-of-type(1) {
        transition: all 0.2s ease-out;
    }

    &:nth-of-type(2) {
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        transition: opacity 0.1s ease-out;
    }

    &:nth-of-type(3) {
        top: auto;
        bottom: 0;

        transition: all 0.2s ease-out;
    }
`